import React, { useEffect } from 'react';
import classNames from 'classnames';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { Caption, BodyMBold } from 'components/Typography/Typography';
import CustomInput from 'components/CustomInput/CustomInput';
import Wifi from '@material-ui/icons/Wifi';
import style from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/linesStyle';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';

// @ts-ignore
const useStyles = makeStyles(style);

const Line = (
	props: types.services.fixed.fixedBusinessBroadband.ILine & {
		name: string;
		handleEditName?: (name: string) => void;
		ind: number;
		showNumber?: boolean;
		iconActive?: boolean;
		disableEdit?: boolean;
		Icon?: any;
		minLineNameLength: number;
		validate?: (name: string, ind: number) => void;
		error?: string;
		loading?: boolean;
	}
) => {
	const {
		handleEditName,
		ind,
		showNumber,
		iconActive,
		name,
		id,
		disableEdit,
		minLineNameLength,
		validate,
		error,
		loading,
	} = props;
	const classes = useStyles({ loading });
	const Icon = props.Icon || Wifi;

	const onChange = (event: any) => {
		const value = event.target.value;
		if (handleEditName) {
			handleEditName(value);
		}
	};

	useEffect(() => {
		if (name.length >= minLineNameLength && !!validate) {
			validate(name, ind - 1);
		}
	}, [name, minLineNameLength, validate, ind]);

	return (
		<div className={classes.line}>
			<ConditionalRender
				show={!!showNumber}
				onTrue={() => (
					<Caption inline color="disabled-light" disableMargin>
						{String(ind)}
					</Caption>
				)}
			/>
			<Icon
				className={classNames(classes.lineIcon, {
					[classes.lineActive]: iconActive,
					[classes.lineInactive]: !iconActive,
				})}
			/>
			<span className={classes.lineInput}>
				<ConditionalRender
					show={!!disableEdit}
					onTrue={() => <BodyMBold disableMargin>{name}</BodyMBold>}
					onFalse={() => (
						<>
							<CustomInput
								key={id}
								id={id}
								formControlProps={{ fullWidth: true }}
								labelText={translate('add.new.line.fbb.username')}
								inputProps={{
									value: name,
									onChange,
								}}
							/>
							<div className={classes.lineNameErrorWrapper}>
								<Caption disableMargin color="danger">
									{error}
								</Caption>
							</div>
							<ConditionalRender
								show={!!loading}
								onTrue={() => (
									<div className={classes.loaderWrapper}>
										<CustomCircularProgress loading text="" transparent />
									</div>
								)}
							/>
						</>
					)}
				/>
			</span>
		</div>
	);
};

export default Line;
